<template>
    <div
        class="slt-max-content-center slt-padding-box mt-12 lg:mx-auto lg:mt-[72px] lg:px-[min(10vw,200px)]"
    >
        <AtomsH3 v-if="shouldRender(title)">
            {{ renderLines(title) }}
        </AtomsH3>

        <ul
            class="mt-6 grid grid-cols-1 gap-4 sm:mt-10 sm:grid-cols-2 sm:gap-10 lg:mt-12"
        >
            <li
                v-for="(h, idx) in state.highlightedPosts"
                :key="idx"
                :class="{ 'sm:col-span-2': idx === 0 }"
            >
                <MoleculesNews
                    :variant="idx === 0 ? 'main' : 'sub'"
                    :news="h"
                />
            </li>
        </ul>
    </div>
</template>

<script setup>
import { renderLines, shouldRender } from "~/lib/utils";

const { title } = defineProps({
    title: {
        type: Array,
        default: () => [],
    },
});

const { state } = usePostsContext();
</script>
